import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ToastService} from "@shared/services/toast.service";

@Injectable({
  providedIn: 'root'
})
export class redemptionpointService {

  constructor(private http: HttpClient, private toast: ToastService) {
  }

  public getRedemptionPoints(params: any) {
    let urlParams = '';
    const size = 'len=5';
    Object.keys(params).forEach((key) => {
      urlParams = urlParams + '&' + key + '=' + params[key];
    });
    let url = 'web/redemption-points?' + size + urlParams;
    return this.http.get(url);
  }

  public getRedemptionPointById(id: any) {
    return this.http.get(`web/redemption-points/${id}`)
  }

  public getCities(countryCode: any) {
    return this.http.get(`cities?countryCode=${countryCode}`)
  }

  public getRedemptionPointCount(params: any) {
    let urlParams = '';
    const size = 'len=5';
    Object.keys(params).forEach((key) => {
      urlParams = urlParams + '&' + key + '=' + params[key];
    });
    let url = 'web/redemption-points/count?' + size + urlParams;
    return this.http.get(url);
  }

  public redeem(code: string) {
    return this.http.post('web/dashboard/redeem?code=' + code, {})
  }

  public createRP(rp: any) {
    return this.http.post('web/redemption-points', rp);
  }

  public UpdateRP(rp: any) {
    return this.http.put(`web/redemption-points/${rp.id}`, rp);
  }

  public verifyName(name: any) {
    return this.http.get(`web/redemption-points/verify-name?rpName=${name}`);
  }

  public deleteRp(id: any) {
    return this.http.delete(`web/redemption-points/${id}`)
  }
}
